import React, { useContext } from "react";
import AppContext from "../contexts/AppContext";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";

// core components
import NavbarDropdown from "../components/navbar_dropdown";
import BreadcrumbsList from "./molecules/breadcrumbs_list";

import componentStyles from "../assets/styles/components/navbar";
const useStyles = makeStyles(componentStyles);

export default function AdminNavbar() {
  const { state } = useContext(AppContext);
  const classes = useStyles();
  return (
    <>
      <AppBar
        position="absolute"
        color="transparent"
        elevation={0}
        classes={{ root: classes.appBarRoot }}
      >
        <Toolbar disableGutters>
          <Container
            maxWidth={false}
            component={Box}
            classes={{ root: classes.containerRoot }}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              width="100%"
              marginTop="0.5rem"
            >
              <div>
                <BreadcrumbsList />
              </div>
              <Box display="flex" alignItems="center" width="auto">
                <NavbarDropdown />
              </Box>
            </Box>
          </Container>
        </Toolbar>
      </AppBar>
    </>
  );
}
